import type { NatalieVersion } from './api/types';

export const NATALIE_VERSION: NatalieVersion = 'v8';
